import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  Alert,
  Modal,
} from 'antd'
import { getCookie } from 'helper/cookie'
import { getDataCompany } from 'api/Admin/company'
import { saveHoliday, updateHoliday } from 'api/Admin/holiday'
import DeleteHoliday from 'common/Management/deletenocheck'
import lang from 'lang/en'
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
let wordError = ''
const Holiday = (props) => {
  const {
    dataAddEditHoliday,
    setVisible,
    visible,
    setCheckChangeTable,
    checkChangeTable,
    permissionPage,
  } = props

  const [form1] = Form.useForm()

  const token = getCookie('access_token_admin')

  //option
  const [dataOptionCompany, setDataOptionCompany] = useState([])
  const [dataOptionOperation, setDataOptionOperation] = useState([])
  const [dataOptionSubOperation, setDataSubOptionOperation] = useState([])

  //set field
  const [companySetfield, setCompanySetfield] = useState()
  const [operationSetfield, setOperationSetfield] = useState()
  const [subOperationSetfield, setSubOperationSetfield] = useState()

  //onchange
  const [onCheckChangeCompany, setOnCheckChangeCompany] = useState(false)

  //delete
  const [visibleDelete, setVisibleDelete] = useState()

  //check id ซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const language = getCookie('lang')
  const word = lang[language]

  const getOptionCompany = async () => {
    await getDataCompany({
      token: token,
      level: 1,
      level_id: 0,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOptionCompany([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (dataAddEditHoliday.parent_ID == item.id) {
              if (language == 'en') {
                setCompanySetfield(item.code + ' ' + item.name_en)
              } else {
                setCompanySetfield(item.code + ' ' + item.name_th)
              }
            }
          })
          setDataOptionCompany(data)
        } else {
          setDataOptionCompany([])

          return true
        }
      })
      .catch((error) => {
        setDataOptionCompany([])

        console.error(error)
      })
  }

  const getOptionOperation = async () => {
    await getDataCompany({
      token: token,
      level: 2,
      level_id: dataAddEditHoliday.parent_ID,
      // level_id: dataAddEditHoliday.dataEdit.company_id,

    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOptionOperation([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (dataAddEditHoliday.level_ID == item.id) {
              if (language == 'en') {
                setOperationSetfield(item.code + ' ' + item.name_en)
              } else {
                setOperationSetfield(item.code + ' ' + item.name_th)
              }
            }
          })

          setDataOptionOperation(data)
        } else {
          setDataOptionOperation([])

          return true
        }
      })
      .catch((error) => {
        setDataOptionOperation([])

        console.error(error)
      })
  }

  const getOptionSubOperation = async () => {
    // console.log(dataAddEditHoliday)
    let levelid = ''
    if (dataAddEditHoliday.state == 'add') {
      levelid = dataAddEditHoliday.level_ID
    } else {
      levelid = dataAddEditHoliday.dataEdit.operation_id
    }
    // console.log(levelid)
    await getDataCompany({
      token: token,
      level: 3,
      level_id: levelid,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataSubOptionOperation([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (dataAddEditHoliday.companyID == item.id) {
              if (language == 'en') {
                setSubOperationSetfield(item.code + ' ' + item.name_en)
              } else {
                setSubOperationSetfield(item.code + ' ' + item.name_th)
              }
            }
          })

          setDataSubOptionOperation(data)
        } else {
          setDataSubOptionOperation([])

          return true
        }
      })
      .catch((error) => {
        setDataSubOptionOperation([])
        // setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (visible == true) {
      dataAddEditHoliday.state == 'edit'
        ? permissionPage.update
          ? setDisablePage(false)
          : setDisablePage(true)
        : _

      getOptionCompany()
      getOptionOperation()
      getOptionSubOperation()
    }
  }, [visible])

  const setfieldifonchange = (state) => {
    if (state == 'Company') {
      form1.setFieldsValue({
        company_code: companySetfield,
        operation_code: null,
        sub_operation_code: null,
      })
    } else if (state == 'Operation') {
      form1.setFieldsValue({
        company_code: companySetfield,
        operation_code: operationSetfield,
        sub_operation_code: null,
      })
    }
  }

  const setField = () => {
    if (dataAddEditHoliday.state == 'add') {
      if (onCheckChangeCompany != false) {
        setfieldifonchange(onCheckChangeCompany)
      } else {
        if (dataAddEditHoliday.level == 1) {
          // console.log(companySetfield)
          form1.setFieldsValue({
            company_code: companySetfield,
            operation_code: null,
            sub_operation_code: null,
          })
        } else if (dataAddEditHoliday.level == 2) {
          // console.log(operationSetfield)
          form1.setFieldsValue({
            company_code: companySetfield,
            operation_code: operationSetfield,
            sub_operation_code: null,
          })
        } else {
          // console.log(subOperationSetfield)
          form1.setFieldsValue({
            company_code: companySetfield,
            operation_code: operationSetfield,
            sub_operation_code: subOperationSetfield,
          })
        }
        form1.setFieldsValue({
          local_holiday_name: null,
          english_holiday_name: null,
        })
      }
    } else {
      if (onCheckChangeCompany != false) {
        setfieldifonchange(onCheckChangeCompany)
      } else {
        form1.setFieldsValue({
          company_code: dataAddEditHoliday.dataEdit.company_code,
          operation_code: dataAddEditHoliday.dataEdit.operation_code,
          sub_operation_code: dataAddEditHoliday.dataEdit.suboperation_code,
          local_holiday_name: dataAddEditHoliday.dataEdit.name,
          english_holiday_name: dataAddEditHoliday.dataEdit.name_en,
        })
      }
    }
  }

  let wordTitle = ''
  if (dataAddEditHoliday.state == 'add') {
    wordTitle = word['Add']
  } else {
    wordTitle = word['Edit']
  }

  const onFinish = (value) => {
    let splitCompanyCode = value.company_code.split(' ')
    let company_id = ''
    dataOptionCompany.map((item) => {
      if (item.code == splitCompanyCode[0]) {
        company_id = item.id
      }
    })

    let splitOperationCode = value.operation_code.split(' ')
    let operation_id = ''
    dataOptionOperation.map((item) => {
      if (item.code == splitOperationCode[0]) {
        operation_id = item.id
      }
    })

    let splitSubOperationCode = value.sub_operation_code.split(' ')
    let suboperation_id = ''
    dataOptionSubOperation.map((item) => {
      if (item.code == splitSubOperationCode[0]) {
        suboperation_id = item.id
      }
    })
    const dataArray = {
      company_id: company_id,
      operation_id: operation_id,
      suboperation_id: suboperation_id,
      name: value.local_holiday_name,
      name_en: value.english_holiday_name,
    }
    if (dataAddEditHoliday.state == 'add') {
      // console.log(dataArray)

      try {
        saveHoliday({
          params: dataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            setVisible(false)
            setnull()
            setCheckChangeTable(checkChangeTable + 1)
            setOnCheckChangeCompany(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_Holiday_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        updateHoliday({
          params: dataArray,
          token: token,
          idCompany: dataAddEditHoliday.dataEdit.id,
        }).then((res) => {
          // console.log(res)
          if (res.status === 200) {
            setHiddenError(true)
            setVisible(false)
            setCheckChangeTable(checkChangeTable + 1)
            setnull()
            setOnCheckChangeCompany(false)
          } else {
            if (res.data.errorCode === '2018') {
              wordError = word['err_Holiday_itemused']
            } else if (res.data.errorCode === '2008') {
              wordError = word['err_Holiday_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onChangeCompany = async (value) => {
    console.log('value', value)
    if (value) {
      let a = value.split(' ')
      setCompanySetfield(value)
      let company_id = ''
      dataOptionCompany.map((item) => {
        if (item.code == a[0]) {
          company_id = item.id
        }
      })
      setOnCheckChangeCompany('Company')

      await getDataCompany({
        token: token,
        level: 2,
        level_id: company_id,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            setDataOptionOperation([])

            return true
          }
          if (status === 200) {
            setDataOptionOperation(data)
          } else {
            setDataOptionOperation([])

            return true
          }
        })
        .catch((error) => {
          setDataOptionOperation([])
          console.error(error)
        })
    }
  }

  const onChangeOperation = async (value) => {
    if (value) {
      let a = value.split(' ')
      setOperationSetfield(value)
      let company_id = ''
      dataOptionOperation.map((item) => {
        // console.log(item.code)
        // console.log(a[0])
        if (item.code == a[0]) {
          company_id = item.id
        }
      })
      setOnCheckChangeCompany('Operation')
      await getDataCompany({
        token: token,
        level: 3,
        level_id: company_id,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            setDataSubOptionOperation([])

            return true
          }
          if (status === 200) {
            setDataSubOptionOperation(data)
          } else {
            setDataSubOptionOperation([])

            return true
          }
        })
        .catch((error) => {
          setDataSubOptionOperation([])
          console.error(error)
        })
    }
  }

  const hoilidayAdd_components = () => {
    setField()
    // console.log(dataOptionCompany)
    // console.log(dataOptionOperation)
    // console.log(dataOptionSubOperation)
    return (
      <div className="holiday-add">
        <div className="holiday-normal-container">
          <Form
            layout="vertical"
            form={form1}
            style={{ width: '100%' }}
            onFinish={onFinish}
          >
            <fieldset disabled={disablePage} className='disable-page'>
              <div hidden={hiddenError}>
                <Alert
                  style={{ marginBottom: 10 }}
                  message={wordError}
                  type="error"
                  showIcon
                />
              </div>
              <Row gutter={16}>
                <Col span={12} style={{ minWidth: '100%' }}>
                  <Form.Item
                    name="company_code"
                    label={word['Business_Code']}
                    rules={[{ required: true, message: 'Please enter business code' }]}
                  >
                    <Select
                      disabled={disablePage}
                      id="selectcompany_code"
                      size="large"
                      placeholder="Business Code"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      onChange={onChangeCompany}
                    >
                      {dataOptionCompany.map((item) => (
                        <Option value={item.code}>
                          {/* {console.log('item', item)} */}
                          {item.code} {language == 'en' ? item.name_en : item.name_th}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="operation_code"
                    label={word['Operation_Code']}
                    rules={[{ required: true, message: 'Please enter operation code' }]}
                  >
                    <Select
                      disabled={disablePage}
                      id="selectoperation_code"
                      size="large"
                      placeholder="Operation Code"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      onChange={onChangeOperation}
                    >
                      {dataOptionOperation.map((item) => (
                        <Option value={item.code}>
                          {item.code} {language == 'en' ? item.name_en : item.name_th}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="sub_operation_code"
                    label={word['Sub_Operation_Code']}
                    rules={[
                      { required: true, message: 'Please enter project type code' },
                    ]}
                  >
                    <Select
                      disabled={disablePage}
                      id="selectsub_operation_code"
                      size="large"
                      placeholder="Project type Code"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {dataOptionSubOperation.map((item) => (
                        <Option value={item.code}>
                          {item.code} {language == 'en' ? item.name_en : item.name_th}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="local_holiday_name"
                    label={word['Local_holiday_name']}
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter local holiday name',
                      },
                    ]}
                  >
                    <Input
                      id="local_holiday_name"
                      size="large"
                      placeholder="Local Holiday Name"
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="english_holiday_name"
                    label={word['English_holiday_name']}
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter english holiday name',
                      },
                    ]}
                  >
                    <Input
                      id="english_holiday_name"
                      size="large"
                      placeholder="English Holiday Name"
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Form>
        </div>
      </div>
    )
  }

  const setnull = () => {
    form1.setFieldsValue({
      company_code: null,
      operation_code: null,
      sub_operation_code: null,
      local_holiday_name: null,
      english_holiday_name: null,
    })
  }

  const onClose = () => {
    setVisible(false)
    setfieldifonchange(false)
    setOnCheckChangeCompany(false)
    setnull()
    setHiddenError(true)
  }
  const renderButton_Drawer = () => {
    if (dataAddEditHoliday.state === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form1.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
            hidden={permissionPage.delete ? false : true}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form1.submit}
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{wordTitle} {word['Holiday']}</TextTitleBold>}
        placement="right"
        onCancel={() => onClose()}
        destroyOnClose
        visible={visible}
        className='fix-modal'
        width={'634px'}
        footer={renderButton_Drawer()}
        centered
      >
        {hoilidayAdd_components()}
        <DeleteHoliday
          state="Holiday"
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          data={dataAddEditHoliday}
          setCheckChangeTable={setCheckChangeTable}
          setVisbleDrawer={setVisible}
        />
      </Modal>
    </>
  )
}
export default Holiday
